import React, {useContext, useEffect, useState} from 'react';
import Select from "react-select";
import moment from "moment";
import axios from "axios";
import {baseURL} from "../../services/api";
import jwtInterceoptor from "../../components/shared/jwtInterceptor";
import {useNavigate, useParams} from "react-router";
import OrgContext from "../../organisation/OrgContext";
import AuthContext from "../../components/shared/AuthContext";
import {formatNumber} from '../../helpers/formater';
import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import { PDFDownloadLink } from '@react-pdf/renderer';
import { useTranslation } from 'react-i18next';
import GoBack from "../../components/goBack";

const PieceDetails = (props) => {
    const {id} = useParams();
    const {organisation, changeOrg} = useContext(OrgContext);
    const {user, logout} = useContext(AuthContext);
    const navigate = useNavigate();

    const [invoice, setInvoice] = useState([]);
    const [suppliers, setSuppliers] = useState([]);
    const [supplier, setSupplier] = useState([]);
    const [spentAccounts, setSpentAccounts] = useState([]);
    const [invoiceId, setInvoiceId] = useState('');
    const [summaryTotatlHt, setSummaryTotatlHt] = useState(0);
    const [summaryTotalTva, setSummaryTotalTva] = useState(0);
    const [summaryTotatlTtc, setSummaryTotatlTtc] = useState(0);

    const [invoiceStatusHistory, setInvoiceStatusHistory] = useState([]);

    //pieces
    const [pieceJournal, setPieceJournal] = useState('');
    const [pieceLibelle, setPieceLibelle] = useState('');
    const [createdAt, setCreatedAt] = useState('');

    const [totalDebit, setTotalDebit] = useState(0);
    const [totalCredit, setTotalCredit] = useState(0);
    const [flux, setFlux] = useState(null);

    const [t, i18n] = useTranslation();

    useEffect(() => {
        getInvoiceData();
    }, []);
    const setData = (piece) => {
        setTotalCredit(piece.total_credit);
        setTotalDebit(piece.total_debit);
        setPieceLibelle(piece.libelle);
        setCreatedAt(piece.created_at);
        setPieceJournal(piece.journal);
    }
    const getInvoiceData = async () => {
        let fst = {};
        let snd = {};
        const response = await jwtInterceoptor.get(`/data/user/piece/signle/${id}`).then(res => {
            console.log(res.data);
            setSpentAccounts(res.data.data[0].debit_credit);
            setData(res.data.data[0]);
            setFlux(res.data.data[0]);
        }).catch((error) => console.log(error));
    }

        // Create styles
        const styles = StyleSheet.create({
            page: {
            // flexDirection: 'row',
            // backgroundColor: '#E4E4E4'
            },
            section: {
                margin: 10,
                padding: 10,
                fontSize: 11,
                //flex: 1,
                // flexGrow: 1,
    
            },
            header: {
                flexDirection: "row",
                marginBottom: 12,
                borderWidth: 1
            },
            cell: {
                borderRightWidth: 1,
                justifyContent: "center",
                alignItems: "center",
                minHeight: 25
            },
            cellRow: {
                minHeight: 25,
                padding: 5,
                paddingTop: 7
            },
            textHeader: {
                fontSize: 10,
                fontWeight: "bold",
                textAlign: "center"
            },
            row: {
                flexDirection: "row",
            },
            textRow: {
                fontSize: 9.5
            },
            headerPage: {
                flexDirection: "row",
                padding: 5,
                borderWidth: 1.5,
                marginBottom: 5
            },
            leftSide: {
                flex: 1,
                justifyContent: "space-between"
            },
            centerContainer: {
                flex: 1,
                justifyContent: "space-between",
                alignItems: "center"
            },
            rightSide: {
                flex: 1,
                justifyContent: "flex-end",
                paddingLeft: 40
            }
        });
    
        // Export to PDF
        const ExportPiece = () => {
            let date_now = new Date();
            let copyIcon = ' © ';
            var PsDate = new Date(flux?.created_at);
            return(
                <Document>
                    <Page size="A4" style={styles.page}>
                        <View style={styles.section}>
                        <View style={styles.headerPage}>
                                <View style={styles.leftSide}>
                                    <Text>{organisation?.name}</Text>
                                    <Text>Impression provisoire</Text>
                                </View>
                                <View style={styles.centerContainer}>
                                    <Text style={{textAlign: "center", fontSize: 18, fontWeight: "bold", marginBottom: 6}}>écreture comptable des pieces</Text>
                                    <View style={{flexDirection: "row"}}>
                                        <Text style={{marginRight: 30, fontSize: 11.5}}>{flux?.journal}</Text>
                                        <Text style={{fontSize: 11.5}}>Piece N° P{flux?.id}</Text>
                                    </View>
                                </View>
                                <View style={styles.rightSide}>
                                    <View style={{flexDirection: "row", justifyContent: "flex-end"}}>
                                        <Text style={{textAlign: "right", marginRight: 4}}>Date Piece : </Text>
                                        <Text style={{textAlign: "right"}}>{moment(PsDate).format("DD/MM/YYYY")}</Text>
                                    </View>
                                </View>
                            </View>
                            <View style={[styles.headerPage, {border: 0, padding: 0}]}>
                                <View style={styles.leftSide}>
                                    <Text style={{fontSize: 9}}>{copyIcon}<Text style={{htmlContnet: '\\00A9'}}></Text>{"ELMANAGER COMMERCIALISATION ET COMPTABILITE"}</Text>
                                </View>
                                <View style={[{justifyContent: "flex-end"}]}>
                                    <View style={{flexDirection: "row", alignItems: "flex-end"}}>
                                        <Text style={{textAlign: "right", marginRight: 4}}>Date de tirage : </Text>
                                        <Text style={{textAlign: "right"}}>{date_now?.getDate()}/{date_now?.getMonth()+1}/{date_now?.getFullYear()} à {date_now?.getUTCHours()+1}:{date_now?.getMinutes() < 10 ? "0"+date_now?.getMinutes() : date_now?.getMinutes()}</Text>
                                    </View>
                                </View>
                            </View>
                            <View style={styles.header}>
                                <View style={[styles.cell, {flex: 2}]}><Text style={styles.textHeader}>Date</Text></View>
                                <View style={[styles.cell, {flex: 2}]}><Text style={styles.textHeader}>N° pièce</Text></View>
                                <View style={[styles.cell, {flex: 2}]}><Text style={styles.textHeader}>N° compte</Text></View>
                                <View style={[styles.cell, {flex: 3}]}><Text style={styles.textHeader}>Nom Compte</Text></View>
                                <View style={[styles.cell, {flex: 3}]}><Text style={styles.textHeader}>Libellé écriture</Text></View>
                                <View style={[styles.cell, {flex: 3}]}><Text style={styles.textHeader}>Débit</Text></View>
                                <View style={[styles.cell, {flex: 3, borderRightWidth: 0}]}><Text>Crédit</Text></View>
                            </View>
                            <View style={{border: 1,}}>
                                {
    
                                    flux?.debit_credit?.map((f_db) =>
                                    {
                                        return (<View key={Math.random()} style={styles.row}>
                                            <View style={[styles.cellRow, {flex: 2}]}><Text style={styles.textRow}>{moment(new Date(f_db?.created_at)).format("DD/MM/YYYY")}</Text></View>
                                            <View style={[styles.cellRow, {flex: 2}]}><Text style={styles.textRow}>P{f_db?.piece_id}</Text></View>
                                            <View style={[styles.cellRow, {flex: 2}]}>
                                                <Text style={styles.textRow}>{f_db?.account?.code}</Text>
                                            </View>
                                            <View style={[styles.cellRow, {flex: 3}]}><Text style={styles.textRow}>{f_db?.account?.name}</Text></View>
                                            <View style={[styles.cellRow, {flex: 3}]}><Text style={styles.textRow}>{flux?.libelle}</Text></View>
                                            <View style={[styles.cellRow, {flex: 3, borderLeftWidth: 1}]}>
                                                <Text style={[styles.textRow, { textAlign: "right" }]}>{Number(f_db?.debit).toFixed(2) }</Text>
                                            </View>
                                            <View style={[styles.cellRow, {flex: 3, borderLeftWidth: 1}]}>
                                                <Text style={[styles.textRow, { textAlign: "right" }]}>{Number(f_db?.credit).toFixed(2) }</Text>
                                            </View>
                                        </View>)
                                    })
                                }
    
                                <View style={[styles.row, {borderTopWidth: 1}]} >
                                    <View style={[styles.cellRow, {flex: 2}]}><Text style={styles.textRow}></Text></View>
                                    <View style={[styles.cellRow, {flex: 2}]}><Text style={styles.textRow}></Text></View>
                                    <View style={[styles.cellRow, {flex: 2}]}><Text style={styles.textRow}></Text>
                                        <Text style={styles.textRow}></Text>
                                    </View>
                                    <View style={[styles.cellRow, {flex: 3}]}><Text style={styles.textRow}></Text></View>
                                    <View style={[styles.cellRow, {flex: 3}]}><Text style={[styles.textRow, { textAlign: "right", fontWeight: "bold" }]}>Totaux</Text></View>
                                    <View style={[styles.cellRow, {flex: 3, borderLeftWidth: 1}]}>
                                        <Text style={[styles.textRow, { textAlign: "right", fontWeight: "bold" }]}>
                                            {Number(flux?.total_debit).toFixed(2)}
                                        </Text>
                                    </View>
                                    <View style={[styles.cellRow, {flex: 3, borderLeftWidth: 1}]}>
                                        <Text style={[styles.textRow, { textAlign: "right", fontWeight: "bold" }]}>
                                            {Number(flux?.total_credit).toFixed(2)}
                                        </Text>
                                    </View>
                                </View>
                               
                            </View>
    
                        </View>
                    </Page>
                </Document>
            )
        };

    return (
        <>
            <div className="container-fluid">
                <GoBack route='piece/list'/>
                <div className="row" style={{zIndex: 1}}>
                    <div className="col-lg-12">
                        <div class="page-header">
                            <h1 class="page-title">Detail de la pièce</h1>
                            <div>
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><a href="javascript:void(0)"
                                                                       onClick={() => navigate('/piece/list')}>list des
                                        pièces</a></li>
                                    <li className="breadcrumb-item active" aria-current="page">details</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-12 col-md-12 card">
                        <div className="card-body">
                            <div class="col-xl-12">
                                <div class="panel panel-primary">

                                    <div class="panel-body tabs-menu-body">
                                        <div class="tab-content">
                                            <div class="tab-pane active">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputEmail1" className="">Journal</label>
                                                    <input type="text" className={`form-control `}
                                                           value={pieceJournal} disabled={true}/>
                                                </div>

                                                <div className="form-group">
                                                    <label htmlFor="exampleInputEmail1" className="">Libelle</label>
                                                    <input type="text" className={`form-control `}
                                                           value={pieceLibelle} disabled={true}/>
                                                </div>

                                                <div className="form-group">
                                                    <label htmlFor="exampleInputEmail1" className="">Date d’opération</label>
                                                    <input type="text" className={`form-control `}
                                                           value={moment(createdAt).format("YYYY-MM-DD")}
                                                           disabled={true}/>
                                                </div>

                                                <table className="table">
                                                    <thead>
                                                    <tr>
                                                        <th scope="col">COMPTE</th>
                                                        <th scope="col">DEBIT</th>
                                                        <th scope="col">CREDIT</th>
                                                    </tr>
                                                    </thead>

                                                    {
                                                        spentAccounts.map((accounts) => {
                                                            return (
                                                                <tr key={accounts.account_id}>
                                                                    <td>{accounts.account.name + ' - '+accounts.account.code}</td>
                                                                    <td>{Number(accounts.debit).toFixed(2)}</td>
                                                                    <td>{Number(accounts.credit).toFixed(2)}</td>
                                                                </tr>
                                                            );
                                                        })
                                                    }

                                                </table>

                                                <div className="row">
                                                    <div className="invoiceSummary">
                                                        <table>
                                                            <tr>
                                                                <td className={'invoiceSummary-base'}>Total debit :</td>
                                                                <td>{Number(totalDebit).toFixed(2)} {organisation?.currency?.code}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className={'invoiceSummary-base'}>Total credit :
                                                                </td>
                                                                <td>{Number(totalCredit).toFixed(2)} {organisation?.currency?.code}</td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </div>

                                                <div className='row d-flex flex-row-reverse'>
                                                    <div className='col-md-4 d-flex flex-row-reverse'>
                                                        {flux ? (
                                                            <PDFDownloadLink
                                                                document={<ExportPiece />}
                                                                fileName={`ec-piece-${flux?.id}.pdf`}
                                                                className='btn btn-info'
                                                                style={{height: 38}}
                                                            >

                                                                {({ blob, url, loading, error }) =>
                                                                loading ? t("Loading document...") : <><span className="fe fe-download"> </span> {t("Exporter")}</>
                                                                }
                                                            </PDFDownloadLink>
                                                        ): null}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="col-xl-4 col-md-12">
                        <div class="tab-pane">
                            <div className="">
                                <div class="container">
                                    <ul class="notification">
                                        {
                                            invoiceStatusHistory.map((invoiceStatus) => {
                                                return (
                                                    <li>
                                                        <div class="notification-icon">
                                                            <a href="javascript:void(0);"></a>
                                                        </div>
                                                        <div class="notification-body">
                                                            <div class="media mt-0">
                                                                <div class="media-body ms-3 d-flex">
                                                                    <div class="">
                                                                        <p class="fs-18 text-dark fw-bold mb-0">
                                                                            <span class="fe fe-clock"> </span>
                                                                            {moment(invoiceStatus.created_at).format("DD/MM/YYYY")}
                                                                        </p>
                                                                        <p class="fs-18 text-dark fw-bold mb-0">{invoiceStatus.status.name}</p>
                                                                        <p style={{display: invoiceStatus.payed_amount === '0' ? 'none' : 'block'}}
                                                                           class="mb-0 fs-13 text-dark">{'Mantant Payé: ' + invoiceStatus.payed_amount + ` ${organisation?.currency?.code}`}</p>
                                                                        <p style={{display: invoiceStatus.payed_amount === '0' ? 'none' : 'block'}}
                                                                           class="mb-0 fs-13 text-dark">{'Réste à payé: ' + invoiceStatus.rap + ` ${organisation?.currency?.code}`}</p>
                                                                        <p class="fs-13 text-dark fw-bold mb-0">{(invoiceStatus.payment_account?.code === undefined && invoiceStatus.payment_account?.name === undefined) ? '' : invoiceStatus.payment_account.code + ' - ' + invoiceStatus.payment_account.name}</p>
                                                                        <p class="fs-11 text-dark fw-bold mb-0">{(invoiceStatus?.banquePaymentOption === undefined && invoiceStatus?.chequeId === undefined) ? '' : invoiceStatus.banquePaymentOption + ' - ' + invoiceStatus.chequeId === null ? '' : invoiceStatus.chequeId}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                );
                                            })
                                        }
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="offcanvas offcanvas-bottom addProductCanvas" tabIndex="-1" id="offcanvasBottom"
                     aria-labelledby="offcanvasBottomLabel">
                    <div class="offcanvas-header">
                        <h5 class="offcanvas-title" id="offcanvasBottomLabel">Renseigner le produit à ajouter.</h5>
                        <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas"
                                aria-label="Close"><i class="fe fe-x fs-18"></i></button>
                    </div>
                    <div class="offcanvas-body">
                        <div id="all-fields-are-required">
                            <div class="alert alert-danger alert-dismissible fade show mb-0" role="alert">
                                <span class="alert-inner--icon"><i class="fe fe-slash"></i></span>
                                <span
                                    class="alert-inner--text"><strong>Attention!</strong> Tous les champs sont obligatoire !</span>
                            </div>
                            <br/>
                        </div>

                        <div id="warning-product-already-exists">
                            <div class="alert alert-danger alert-dismissible fade show mb-0" role="alert">
                                <span class="alert-inner--icon"><i class="fe fe-slash"></i></span>
                                <span
                                    class="alert-inner--text"><strong>Attention!</strong> Le produit déja exist !</span>
                            </div>
                            <br/>
                        </div>

                        <div id="qty-is-higher">
                            <div class="alert alert-danger alert-dismissible fade show mb-0" role="alert">
                                <span class="alert-inner--icon"><i class="fe fe-slash"></i></span>
                                <span class="alert-inner--text"><strong>Attention!</strong> L'article choisie est en rupture de stock</span>
                            </div>
                            <br/>
                        </div>

                    </div>
                </div>

            </div>
        </>
    );
}

export default PieceDetails;